import React from 'react'
import { DefaultLayout } from '../../layouts'
import { PageDataFetcher, PageHeader } from '../../components'
import { PageContent } from './components'
import { fetchResources as fetcher, setQuery } from '../../features/resources/slice'
import { useInternationalization } from '../../features/i18n/hook'
import * as pageConfig from './config'
import AudienceListener from '../../features/collection/components/audience-listener'
const { PAGE_IMAGE, STATE_KEY } = pageConfig

const Resource = (props) => {
  const { translate } = useInternationalization()

  return (
    <DefaultLayout>
      <AudienceListener />
      <PageDataFetcher
        stateKey={STATE_KEY}
        fetcher={fetcher}
        querySetter={setQuery}
        pageConfig={pageConfig}
        {...props}
      >
        <PageHeader
          title={translate('RESOURCE', 'plural')}
          description={translate('RESOURCE', 'page_description')}
          image={PAGE_IMAGE}
          className="py-5 lg:pb-6 lg:pt-0"
        />
        <PageContent />
      </PageDataFetcher>
    </DefaultLayout>
  )
}

export { Resource }
